export const getParentElements = (element: HTMLElement): HTMLElement[] => {
  const parents = []

  let parent = element.parentElement
  while (parent) {
    parents.push(parent)
    parent = parent.parentElement
  }

  return parents
}

/**
 * A throttle function which uses requestAnimationFrame.
 * Triggers callback with the latest arguments when the next frame is available.
 */
export function requestAnimationFrameThrottle<T extends (...args: never[]) => void>(
  callback: T
): (...args: Parameters<T>) => void {
  let scheduled = false
  let latestArgs: Parameters<T>

  return (...args: Parameters<T>) => {
    latestArgs = args

    if (!scheduled) {
      scheduled = true
      requestAnimationFrame(() => {
        scheduled = false
        callback(...latestArgs)
      })
    }
  }
}

export function isScrollParent(element: HTMLElement): boolean {
  const values = ['auto', 'scroll']
  const {overflow, overflowX, overflowY} = getComputedStyle(element)
  return [overflow, overflowX, overflowY].some(prop => values.includes(prop))
}

export function getScrollParents(element: HTMLElement | null): Array<HTMLElement> {
  if (!element || element === document.body) {
    return []
  }

  const results: Array<HTMLElement> = []

  if (isScrollParent(element)) {
    results.push(element)
  }

  results.push(...getScrollParents(element.parentElement))

  return results
}
